import type { ReactNode } from 'react';
import { AvailabilityEditor as SharedAvailabilityEditor } from '../../../components/AvailabilityEditor';
import { useToasts } from '../../../stores/toasts';
import { useSetAvailability, type AvailabilityRow } from '../api/users-api';

/**
 * USER-02's availability card: the shared editor (S19 moved it to `components/` so
 * "My availability" can use it too), saving through this person's record.
 */
export function AvailabilityEditor({
  userId,
  rows,
  canEdit,
}: {
  readonly userId: string;
  readonly rows: readonly AvailabilityRow[];
  readonly canEdit: boolean;
}): ReactNode {
  const save = useSetAvailability(userId);
  const showToast = useToasts((state) => state.show);
  return (
    <SharedAvailabilityEditor
      rows={rows}
      canEdit={canEdit}
      isSaving={save.isPending}
      // The rows this edit started from: a save replaces them all, so a save made since is a 409 rather than
      // silently overwritten (S7), as on My availability.
      onSave={(input) =>
        save.mutate({ ...input, baseIds: rows.map((row) => row.id) }, {
          onSuccess: () => showToast({ tone: 'success', message: 'Availability saved' }),
          onError: (error) => showToast({ tone: 'danger', message: error.message }),
        })
      }
    />
  );
}

export { describeAvailability } from '../../../components/AvailabilityEditor';
